module.exports = __webpack_public_path__ + "public/img/not-found.c8cb763d.svg";